module.exports = __webpack_public_path__ + "static/media/Half_W_Art_Img_01.b31960f7.jpg";